























import { UserInfo } from '@/interfaces/vuexStateInterface';
import { updateInfo } from '@/apis/myInfo/myInfo.ts';
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import i18n from '@/lang';

@Component({})
export default class InterSchoolTime extends Vue {
  get userInfo(): UserInfo {
    return this.$store.getters.getUserInfo;
  }
  private schoolTime = '';
  private show: boolean = false;
  private isSchool: number = -1;
  private yearArr: any = [];
  private columns: any = [
    {
      values: [],
      defaultIndex: this.yearArr.length
    },
    {
      values: [],
      defaultIndex: 0
    }
  ];
  private selectDate = new Date();
  private moment = moment;
  private minDate = new Date(1990, 0, 1);
  change(index: any, val: any) {
    if (val[0] == this.yearArr[this.yearArr.length - 1]) {
      let myDate = new Date();
      let nowMonth = myDate.getMonth() + 1;
      for (let i = 0; i < nowMonth; i++) {
        this.columns[1].values[i] = nowMonth + '月';
      }
    } else {
      this.columns[1].values = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
    }
  }

  //确定
  confim(val: any, index: any) {
    const date = moment(this.selectDate).format('YYYY-MM'); // 入学时间
    this.$dialog
      .confirm({
        title: i18n.t('ktpMy.确定更改入学时间吗') as string
      })
      .then(() => {
        // const schoolTime = this.columns[0].values[index[0]] + this.columns[1].values[index[1]]
        updateInfo({
          username: this.userInfo.username,
          school: this.userInfo.school,
          department: this.userInfo.department,
          teachcourse: this.userInfo.teachcourse,
          stno: this.userInfo.stno,
          majors: this.userInfo.majors,
          classno: this.userInfo.additionInfo!.classno,
          enrolltime: date,
          grade: this.userInfo.additionInfo!.grade
        })
          .then((res: any) => {
            this.$dialog
              .alert({
                title: i18n.t('ktpMy.入学时间修改成功') as string
              })
              .then(() => {
                this.$store.dispatch('setUserInfo').then(() => {
                  this.$router.back();
                });
              });
          })
          .catch(e => {});
      })
      .catch(() => {
        this.show = false;
      });
  }
  cancel() {
    this.show = false;
  }
  showPopup() {
    this.show = true;
  }
  created() {
    this.$setNavInfo({
      type: 'normal',
      title: i18n.t('CourseHome.入学时间') as string,
      showTitle: true
    });
    this.getYear();
    this.schoolTime = this.userInfo!.additionInfo!.enrolltime || i18n.t('CourseHome.请选择入学时间') as string;
  }

  getYear() {
    let myDate = new Date();
    let nowYear = myDate.getFullYear();
    let nowMonth = myDate.getMonth() + 1;
    for (let i = 0; i <= nowYear - 2000; i++) {
      // this.yearArr.push[i]
      if (i < 10) {
        this.yearArr[i] = '200' + i + i18n.t('ktpMy.年');
      } else {
        this.yearArr[i] = '20' + i + i18n.t('ktpMy.年');
      }
    }
    for (let j = 0; j < nowMonth; j++) {
      this.columns[1].values[j] = j + 1 + '月';
    }

    this.columns[0].values = this.yearArr;
    this.columns[0].defaultIndex = this.yearArr.length;
  }
  formatter(type: string, val: string) {
    if (type === 'year') {
      return `${val} ${i18n.t('ktpMy.年') }`;
    }
    if (type === 'month') {
      return `${val} ${i18n.t('ktpMy.月') }`;
    }
    return val;
  }
}
